// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-3iFw_";
var _3 = "root_zeroPrice-2jso-";
var _4 = "root__text-2Z668";
var _5 = "root__money-2vkpl";
var _6 = "money-1RcKf";
var _7 = "amount-3bmmC";
var _8 = "currency-lpvsa";
export { _1 as "__esModule", _2 as "root", _3 as "root_zeroPrice", _4 as "root__text", _5 as "root__money", _6 as "money", _7 as "amount", _8 as "currency" }
export default { "__esModule": _1, "root": _2, "root_zeroPrice": _3, "root__text": _4, "root__money": _5, "money": _6, "amount": _7, "currency": _8 }
